import { appData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 max-w-5xl mx-auto">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
              {appData.title}
            </h2>
            <p className="text-sm md:text-base text-foreground-600 mb-8">
              {appData.subtitle}
            </p>
            <ul className="space-y-3 mb-8">
              {appData.features.map((feat) => (
                <li key={feat} className="flex items-center gap-3 text-sm text-foreground-700">
                  <span className="w-6 h-6 flex items-center justify-center bg-primary-100 text-primary-600 rounded-full flex-shrink-0">
                    <i className="ri-check-line text-sm"></i>
                  </span>
                  {feat}
                </li>
              ))}
            </ul>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#"
                className="px-8 py-3 text-sm font-semibold text-background-50 bg-foreground-900 hover:bg-foreground-800 rounded-md transition-colors whitespace-nowrap cursor-pointer flex items-center gap-2"
              >
                <i className="ri-apple-line text-lg"></i>
                App Store 下载
              </a>
              <a
                href="#"
                className="px-8 py-3 text-sm font-semibold text-foreground-700 bg-background-50 border border-background-300 hover:bg-background-200 rounded-md transition-colors whitespace-nowrap cursor-pointer flex items-center gap-2"
              >
                <i className="ri-android-line text-lg"></i>
                Android 下载
              </a>
            </div>
          </div>

          <div className="flex-shrink-0 w-56 md:w-64">
            <div className="relative">
              <div className="w-full aspect-[3/4] rounded-2xl overflow-hidden bg-background-200 border-4 border-background-50">
                <img
                  src={appData.image}
                  alt="91影视App移动端界面展示"
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    (e.currentTarget as HTMLImageElement).style.display = 'none';
                  }}
                />
              </div>
              <div className="absolute -bottom-3 -right-3 w-16 h-16 bg-accent-500/20 rounded-xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}